export default __webpack_public_path__ + "static/hacktoberfest2020-423cb204c8818df58fb8f6090191c987.webp";